<template>
  <v-select
    :items="functions"
    :value="value"
    @input="$emit('input',$event)"
    :hide-details="!isRequired"
    :label="title"
    filled
    clearable
    :rules="rules"
  ></v-select>
</template>

<script>
export default {
  name: "FilterFunctionPicker",

  props: ["value", "isRequired", "title"],

  data() {
    return {
      functions: []
    };
  },

  computed: {
    rules() {
      if (this.isRequired) {
        return [v => !!v || "Required"];
      }

      return [];
    }
  },

  created() {
    this.$store
      .dispatch("cache/getObject", {
        apiName: "datafunctions"
      })
      .then(response => (this.functions = response));
  }
};
</script>
